import { account } from '../../../classes/Account'
import DashboardClientTile from './components/DashboardTiles/DashboardClientTile'
import DashboardProgressTracker from './components/DashboardProgressTracker'
import DashboardAgentTile from './components/DashboardTiles/DashboardAgentTile'
import DashboardStepTile from './components/DashboardTiles/DashboardStepTile'
import { useNavigate, useParams } from 'react-router-dom'
import DashboardFMP from './components/DashboardFMP'
import { useEffect, useState } from 'react'
import { apiURL } from '../../../utilities/URLs'
import { Stage } from './classes/Stage'
import { refreshAccessToken } from '../../../utilities/extensions'

export default function ApplicationDashboard() {
  const { applicationId } = useParams()
  const navigate = useNavigate()
  const [stage, setStage] = useState(new Stage())

  useEffect(() => {
    const handleGetStage = async () => {
      const stageResponse = await fetch(`${apiURL}/api/applications/${applicationId}/stage/`, {
        method: 'GET',
        headers: {
          'Authorization': account.accessToken
        }
      })
      const stageData = await stageResponse.json()
      if (stageData.response.error) {
        if (stageData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGetStage() : navigate('/', { state: { expired: true } })
        } else
          console.error(stageData.response.error)
      } else
        setStage(new Stage({ ...stageData.response.stage, hasActiveUploadWorkflow: stageData.response.hasActiveUploadWorkflow }))
    }

    handleGetStage()
  }, [])

  return (
    <div className='w-full flex-1 flex flex-col p-4 md:p-8 lg:p-12'>
      <div className='mb-8'>
        <h1 className='text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white mb-2'>Welcome Back, {account.name}</h1>
        <p className='text-slate-500 dark:text-slate-400'>Here is an overview of your application status.</p>
      </div>
      <div className='w-full flex-1 flex flex-col gap-6'>
        <div className='w-full flex flex-col lg:flex-row self-center gap-6 mb-2'>
          <DashboardStepTile applicationId={applicationId} />
          <DashboardClientTile />
          <DashboardAgentTile applicationId={applicationId} stageId={stage.stageId} />
        </div>
        {(stage.groupId === 'd341169a-dc8a-4d78-abea-d7d821dccbc8' || stage.groupId === 'fb7c3669-ad5f-4ce6-ac2a-f3311a739e79') ? (
          <DashboardFMP />
        ) : (
          <DashboardProgressTracker applicationId={applicationId} stageId={stage.stageId} hasActiveUploadWorkflow={stage.hasActiveUploadWorkflow} />
        )}
      </div>
    </div>
  )
}